<template>
  <div v-if="loading">
    <Loading/>
  </div>
  <div v-else class="segments">
    <ImageList :items="sortedSegments"/>
  </div>
</template>

<script>
import ImageList from '@/components/elements/ImageList'
import Loading from '@/components/elements/Loading'

export default {
  name: 'Segments',
  components: {
      'ImageList': ImageList,
      'Loading': Loading,
  },
  data () {
    return {
      segments: [],
      loading: true
    }
  },
  computed: {
    sortedSegments() {
      return this.segments.sort( (a, b) => {
          if (a.linkText.toUpperCase() < b.linkText.toUpperCase())
            return -1;
          if (a.linkText.toUpperCase() > b.linkText.toUpperCase())
            return 1;
          return 0;
        }
      );
    }
  },
  created: function() {
   
    
    this.$http.get(this.config.webserviceUrl,{
      params: {
        action: 'getSegmentsForIndustry',
        industry: this.$route.params.id
      }
    })
    .then(response => {
      for (var i in response.body) {
        if ( typeof(response.body[i]) == 'object' ) {
          response.body[i].linkTo = 'Application';
          if ( response.body[i].visible == null ) {
            response.body[i].visible = true;
           	
          }
          
         
           
           
          this.segments.push(response.body[i]);
        }
      }
      this.loading = false;
      
    });
    
   
    
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Segments.vue